import { Link, useLocation } from 'react-router-dom'
import { cn } from '@/lib/utils/cn'
import { IconHome, IconTrending, IconSearch, IconBell, IconUser, IconMessage } from '@/components/ui/Icons'

interface MobileNavProps {
  user: { username: string } | null
}

export function MobileNav({ user }: MobileNavProps) {
  const location = useLocation()

  const items = [
    { href: '/feed', label: 'Feed', icon: IconHome },
    { href: '/trending', label: 'Trending', icon: IconTrending },
    { href: '/search', label: 'Search', icon: IconSearch },
    ...(user ? [
      { href: '/notifications', label: 'Alerts', icon: IconBell },
      { href: '/messages', label: 'DMs', icon: IconMessage },
    ] : []),
    ...(user ? [{ href: "/profile/" + user.username, label: 'Profile', icon: IconUser }] : []),
  ]

  const isActive = (href: string) => location.pathname === href || location.pathname.startsWith(href + '/')

  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 mobile-nav-ig h-16 z-40">
      <div className="flex items-center justify-around h-full px-2 max-w-screen-sm mx-auto">
        {items.map(({ href, label, icon: Icon }) => (
          <Link key={href} to={href}
            className={cn(
              "flex flex-col items-center gap-1 px-3 py-1.5 rounded-xl transition-colors min-w-[44px] relative",
              isActive(href) ? "text-foreground" : "text-text-muted"
            )}>
            <div className={cn("relative", isActive(href) && "ig-active-dot")}>
              <Icon className={cn("w-6 h-6", isActive(href) ? "text-foreground" : "text-text-muted")} />
            </div>
            <span className="text-[10px] font-medium">{label}</span>
          </Link>
        ))}
      </div>
    </nav>
  )
}